import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@src/common/Button';
import { IconExpandLess } from '@src/common/Icon/IconExpandLess';
import { IconExpandMore } from '@src/common/Icon/IconExpandMore';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { useHeaderMenu } from '@src/state/headerMenu';

export const MyAccountButton = ({ openDropdown, isActive, ...props }) => {
  const { isMyAccountOpen } = useHeaderMenu.state();

  useEffect(() => {
    if (isMyAccountOpen) {
      openDropdown();
    }
  }, [isMyAccountOpen]);

  return (
    <Button
      id="myaccount-button"
      {...props}
      variant="tertiary"
      size="14px"
      before={<IconSymbol size={18} icon="account_circle" />}
      after={
        isActive ? (
          <IconExpandLess size={25} color="info1" />
        ) : (
          <IconExpandMore size={25} color="info1" />
        )
      }
      css={{
        height: 'auto',
        paddingTop: '3px',
      }}
    >
      My Account
    </Button>
  );
};

MyAccountButton.propTypes = {
  openDropdown: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};
